/* eslint-disable */
import usersService from "services/usersService";
import { getAuth } from "firebase/auth";
import config from "../config/auth.config";

/**
 * postAuthGate
 * ----------------------------------------------------------
 * SNS / PASS / 알림톡 인증 완료 직후 다음 경로를 결정.
 * - Firebase Auth는 이미 로그인 상태(익명 포함)
 * - users 문서 ensureUserDoc으로 최소 보정만 수행
 * - PASS/알림톡 모두 phoneE164 존재 여부로 인증 여부 판단
 * - 약관/추가정보 판단은 각 프로젝트에서 처리
 */

export async function postAuthGate(provider /* "google"|"kakao"|"naver"|"sso" */, returnTo) {
    const auth = getAuth();
    const u = auth.currentUser;
    const home = config?.postSignInRoute || "/home";
    const signOut = config?.postSignOutRoute || "/loginlanding";
    const method = (config?.phoneAuth?.method || "pass").toLowerCase();

    if (!u) {
        console.warn("[postAuthGate] no current user");
        return { ok: false, reason: "no-auth", redirectTo: signOut };
    }

    // 1️⃣ users/{uid} 최소 스키마 보정 (idempotent)
    try {
        const prov = (provider || "sso").toLowerCase();
        await usersService.ensureUserDoc(u.uid, {
            provider: prov,
            email: u.email || null,
            displayName: u.displayName || null,
            loginMethodToSet: prov,
        });
    } catch (e) {
        console.warn("[postAuthGate] ensureUserDoc failed:", e);
    }

    // 2️⃣ users 문서 다시 조회
    let doc = null;
    try {
        doc = await usersService.getUser(u.uid);
    } catch (e) {
        console.warn("[postAuthGate] getUser failed:", e);
    }

    // 3️⃣ 인증 확인 (전화번호 존재 여부)
    const verified = !!doc?.phoneE164;

    // 4️⃣ 다음 경로 결정
    return {
        ok: true,
        uid: u.uid,
        redirectTo: verified
            ? (returnTo || home)
            : `/auth/phone${returnTo ? `?returnTo=${encodeURIComponent(returnTo)}` : ""}`,
    };
}

export default { postAuthGate };
